import { HashRouter, Route, Routes, useLocation } from "react-router-dom";  
import Navbar from "./Webpage/navbar.js";  
import FeedbackDashboard from "./Webpage/feedbackpage.js";  
import Broadcast from "./Webpage/Broadcast.js";  
import { SignIn } from "./Webpage/SignIn.js";  
import Footer from "./Webpage/footer.js";  
import { KPIDashboard } from "./Webpage/Kpidetails.js";  
import Chatbot from "./Webpage/chatbot.js";  
import KmFeedback from "./Webpage/KmFeedback.js";
import TransDash from "./Webpage/TransDash.js";
  
function App() {  
  const ShowNavbar = () => {  
    const location = useLocation();  
    const excludedRoutes = ["/"];  
    return !excludedRoutes.includes(location.pathname) && <Navbar />;  
  };  
  
  const ShowFooter = () => {  
    const location = useLocation();  
    const excludedRoutes = ["/"];  
    return !excludedRoutes.includes(location.pathname) && <Footer />;  
  };  
  
  const ShowChatbot = () => {  
    const location = useLocation();  
    const excludedRoutes = ["/"];  
    return !excludedRoutes.includes(location.pathname) && <Chatbot />;  
  };  
  
  return (  
    <HashRouter>  
      <div className="App">  
        <ShowNavbar />  
        <ShowFooter />  
        {/* <ShowChatbot /> */}  
        <Routes>  
          <Route path="/" element={<SignIn />} />  
          <Route path="/broadcastmessage" element={<Broadcast />} />  
          <Route path="/dashboard" element={<h1>This is for dashboard</h1>} />  
          <Route path="/kpidetails" element={<KPIDashboard />} />  
          <Route path="/profile" element={<h1>Profile</h1>} />  
          <Route path="/feedback" element={<FeedbackDashboard />} />  
          <Route path="/kmanalysis" element={<KmFeedback />} />  
          <Route path="/chatbot" element={<Chatbot />} />  
          <Route path="/transcript" element={<TransDash />} />  
          {/* <Route path="/logout" element={<SignIn />} /> */}  
        </Routes>  
      </div>  
    </HashRouter>  
  );  
}  
  
export default App;  
